import React from "react";
import { Dropdown, Input } from "semantic-ui-react";
const SearchBar = ({ filter, onChangeFilter, options }) => {
  return (
    <>
      <div
        style={{ float: "left", marginBottom: "1rem", paddingRight: "1rem" }}
      >
        <Input
          value={filter.value}
          iconPosition="left"
          icon="search"
          placeholder="Search by..."
          style={{ maxWidth: "24em" }}
          onChange={onChangeFilter}
        />
      </div>
      <div
        style={{ float: "left", marginBottom: "1rem", paddingRight: "1rem" }}
      >
        <Dropdown
          value={filter.column}
          selection
          options={options}
          onChange={onChangeFilter}
        />
      </div>
    </>
  );
};

export { SearchBar };
